import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MessageService, HttpService, LocalStorageService } from 'brainloper-ui';
import { Router } from '@angular/router';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { UserAuth } from 'src/app/models/auth/user-auth';
import { ValidateUserLogin } from 'src/app/models/auth/validate-user-login';
import { BaseResponse } from 'src/app/models/commos/base-response';
@Component({
    selector: 'app-login-page',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss'],
    standalone: false
})
export class LoginPageComponent implements OnInit {

  public loginForm: UntypedFormGroup
  private urlValidateUser = `${EndpointDictionary.Login.VALIDATE_USER}`

  public baseUrl: String = `${EndpointDictionary.Base._BASE_URL_V2}`

  public selelectCompany : boolean = false
  public companias: Array<UserAuth>;

  public  hide = true;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private message : MessageService,
    private http : HttpService,
    private router : Router,
    private storage : LocalStorageService,
    private authenticationService : AuthenticationService
  ) {
    this.message.closeLoading()
    this.loginForm = this.formBuilder.group({
      user:'',
      password:''
    })
   }


  ngOnInit(): void {
    if(this.storage.get<string>('token')){
      this.router.navigate(['inicio'])
    }else{
      this.authenticationService.Logout()
    }
  }

  async onSubmit($event){
    $event.preventDefault();
    this.message.openLoading('Cargando...', 'Verificando usuario')

    let validateUser: BaseResponse<ValidateUserLogin> = await this.http.postDataPromise(this.urlValidateUser, this.loginForm.value)


    if(validateUser['code'] === 0){
      this.storage.set<string>('token', validateUser.body.token)
      this.storage.set<string>('traccarToken', validateUser.body.traccarToken)
      if(validateUser.body.users.length == 1){
        delete validateUser.body.users[0].companyName
        delete validateUser.body.users[0].companyLogo
        this.selelectCompany = false
        this.authenticationService.login(validateUser.body.users[0])
      }else{
        this.companias = validateUser.body.users
        this.selelectCompany = true
        this.message.closeLoading()
      }
    }else{
      this.message.Error('Error de acceso', `Código: ${validateUser['code']} - ${validateUser['message']}`)
      this.message.closeLoading()
    }


  }

  handleClick($event, user:UserAuth){
    $event.preventDefault();
    if(user.userId == 0) {
      this.selelectCompany = false
      return
    }

    this.authenticationService.login(user)
    this.selelectCompany = false
    this.message.openLoading('Cargando...', 'Verificando usuario')
  }


  errorMsg(){
    this.message.ErrorToast('Debe completar los campos')
  }


}
